// extracted by mini-css-extract-plugin
module.exports = {"menu":"desktop_type-module__menu--2GOXY","separator":"desktop_type-module__separator--3BnC2"};